import { EmployeeRole } from "types/globalTypes";

export const checkIfAllHoldingsRole = (value: any): boolean => 
    value === EmployeeRole.Admin || value === EmployeeRole.Marketer;
